import { NotificationsConfig } from "./notifications/NotificationsConfig.ts";
import { AuthenticationConfig } from "./authentication/AuthenticationConfig.ts";
import { AppFwApiClient } from "./api-client/AppFwApiClient.ts";
import { QueryClient } from "@tanstack/react-query";

export interface AppFwConfiguration {
    appName: string;
    authentication: AuthenticationConfig;
    notifications?: NotificationsConfig;
}

export class AppFwContext {

    public queryClient = new QueryClient()

    public appFwApiClient: AppFwApiClient
    private refreshCallbacks: Set<() => void | Promise<void>> = new Set()

    public constructor(public configuration: AppFwConfiguration) {
        this.appFwApiClient = new AppFwApiClient(this.configuration)
    }

    public registerRefreshCallback(callback: () => void | Promise<void>): () => void {
        this.refreshCallbacks.add(callback);
        return () => {
            this.refreshCallbacks.delete(callback);
        };
    }

    public async triggerRefresh() {
        console.log(`[AppFw] Triggering refresh for ${this.refreshCallbacks.size} callbacks...`);
        const promises = Array.from(this.refreshCallbacks).map(async (cb) => {
            try {
                await cb();
            } catch (e) {
                console.error("[AppFw] Error during refresh callback execution", e);
            }
        });
        await Promise.all(promises);
    }
}